import { Box } from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import ReactApexChart from "react-apexcharts";

export default function TripleChart({ projected, actual, expenses }) {
  useEffect(() => {
    setChart({
      series: [
        {
          name: "Projected Income",
          data: projected,
        },
        {
          name: "Actual Income",
          data: actual,
        },
        {
          name: "Expenses",
          data: expenses,
        },
      ],
    });
  }, [projected, actual, expenses]);

  const [chart, setChart] = useState({
    series: [
      {
        name: "Projected Income",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "Actual Income",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "Expenses",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        title: {
          text: "Amount  (₦)",
        },
      },
      fill: {
        opacity: 1,
      },

      tooltip: {
        y: {
          formatter: function (val) {
            return "₦ " + val;
          },
        },
      },
    },
  });
  return (
    <Box w="100%">
      <ReactApexChart
        options={chart.options}
        series={chart.series}
        type="bar"
        height={350}
        width="100%"
      />
    </Box>
  );
}
